// AuthHandler.jsx — full replacement
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { savePendingAuth } from "./authStorage";

const AuthHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const authenticateUser = () => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("token");

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const decodedToken = atob(token);
        const payload = JSON.parse(decodedToken);

        // Same rule as the password flow: stash only, write nothing to
        // localStorage until OTPVerification confirms the code.
        savePendingAuth({
          authType: "sso",
          rawToken: token,
          payload,
        });

        navigate("/otp-verification");
      } catch (error) {
        console.error("Authentication error:", error);
        navigate("/login");
      }
    };

    authenticateUser();
  }, [navigate, location]);

  return <div>Authenticating...</div>;
};

export default AuthHandler;